import React from 'react';
import Profile from '../admin/Profile';

const SuperAdminProfile = () => <Profile />;

export default SuperAdminProfile;
